function Tools() {
  return (
    <>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-12">
        <div className="w-full flex flex-col items-start justify-center gap-2 text-left">
          <h2 className="uppercase color-yellow text-xl">Sprzęt</h2>
          <h3 className="text-3xl lg:text-5xl color-green">
            Sprzęt, który <span className="color-yellow">sprawdzi się</span>
            <br></br>w każdych warunkach
          </h3>
          <p className="text-gray-600">
            Używamy maszyn Bobcat i John Deere. Jest to sprzęt renomowanych
            firm. Posiadamy kilka modeli Bobcatów. Dobieramy narzędzia do
            warunków na działce. Mały Bobcat jest niewielki i bardzo zwinny.
            Dzięki temu wjedzie w każde miejsce. Większy Bobcat służy do zadań
            specjalnych. Ma wystarczająco dużo mocy, by wykonać nawet najcięższe
            prace.
          </p>
          <span className="bg-green h-[1px] mt-6 w-full"></span>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-1.png"
                alt="Bobcat - miniładowarka używana przez Drzewus"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-2.png"
                alt="John Deere - ciągnik ogrodniczy używany przez Drzewus"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/tools-3.png"
                alt="Profesjonalny sprzęt ogrodniczy Drzewus"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/stihl-logo.png"
                alt="Logo Stihl - piły i narzędzia ogrodnicze"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/fiskars-logo-1.jpg"
                alt="Logo Fiskars - narzędzia ogrodnicze"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/Kubota_Logo.svg_.png"
                alt="Logo Kubota - ciągniki i maszyny budowlane"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              {" "}
              <img
                src="https://magazyn.drzewus.pl/wp-content/uploads/2026/05/kubota-logo.webp"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-6 w-full">
          <div className="h-[175px] flex flex-col items-center justify-center rounded-xl lg:col-span-3 overflow-hidden">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/8xxcBcJ1.jpg"
              alt="Miniładowarka Bobcat podczas prac na działce - Drzewus"
              className="w-full h-full object-cover scale-105"
            />
          </div>
          <div className="h-[175px] flex flex-col items-center justify-center rounded-xl lg:col-span-2 overflow-hidden">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/173834742_3889065271160894_2774805985151210818_n.jpg"
              alt="Maszyny Drzewus w akcji - profesjonalne prace ziemne"
              className="w-full h-full object-cover scale-105"
            />
          </div>
          <div className="h-[175px] flex flex-col items-center justify-center rounded-xl lg:col-span-2 overflow-hidden">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/Kubota-Drzewus-2.jpg"
              alt="Kubota - ciągnik Drzewus podczas prac ogrodniczych"
              className="w-full h-full object-cover scale-105"
            />
          </div>
          <div className="h-[175px] flex flex-col items-center justify-center rounded-xl lg:col-span-3 overflow-hidden">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Sprzet-ktory-sprawdzi-sie-w-kazdych-warunkach.jpg"
              alt="Profesjonalny sprzęt Drzewus sprawdzający się w każdych warunkach"
              className="w-full h-full object-cover scale-105"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Tools;
